// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HH2cchJV1GQvjDG754Hs{flex-direction:column;width:100%;height:100%;display:flex;position:relative}.NFqChp3HlIMjuZZpyfJH{min-height:52px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listPageContainer": `HH2cchJV1GQvjDG754Hs`,
	"filterWrapper": `NFqChp3HlIMjuZZpyfJH`
};
export default ___CSS_LOADER_EXPORT___;
